import { TipoDespesa } from '../_models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlertService } from '../_services/alert.service';
import {environment} from '../../environments/environment';


@Injectable({
    providedIn: 'root'
})

export class TipoDespesaService {

    getTipoDespesas(tipoDoc: string): Observable<any> {
        return this.http.get<TipoDespesa[]>(`${environment.apiUrl}/api/TipoDespesa?tipoDocumento=` + tipoDoc);
    }

    constructor(private http: HttpClient,
        private alertService: AlertService) { }


}
